// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mode-preview"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 19H2.00099L2 4H22L22 19L18.5 19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 19.5L10.5 21L13.5 21L12 19.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ModePreviewIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mode-preview',
    ref,
    icon: element,
  },
));

ModePreviewIcon.displayName = 'ModePreviewIcon';

export default ModePreviewIcon;
